import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PRODUCT_STATUS } from 'domains/inventory/constants/inventory-constants'


const propTypes = {
  product_status: PropTypes.string
}

const PRODUCT_STATUS_UI_LABELS = {
  [PRODUCT_STATUS.ENABLED]  : 'available',
  [PRODUCT_STATUS.DISABLED] : 'not_available',
  available                 : 'available',
  not_available             : 'not_available'
}

/**
 * To give nice look on Inventory `product_status`.
 * It maps `product_status` to certain style and pass to `StatusBadge`.
 * @param {string} product_status Inventory Product status. available values
 * - `disabled`
 * - `enabled`
 */
const ProductStatusBadge = ({ product_status, ...props }) => {

  const colorMap = {
    [PRODUCT_STATUS.ENABLED]  : 'success',
    [PRODUCT_STATUS.DISABLED] : 'danger',
    available                 : 'success',
    not_available             : 'danger'
  }

  const color = colorMap[product_status]
  const label = PRODUCT_STATUS_UI_LABELS[product_status] || product_status

  return <StatusBadge color={ color } label={ label } { ...props } />
}

ProductStatusBadge.propTypes = propTypes

export default ProductStatusBadge